import Logos from "../components/images/Logo";

import logoTest from "../assets/images/partners/platfrom.png";
import logoCover from "../assets/images/partners/cover.png";

const phenix295 = {
  app_name: `Phenix295`,
  prefix: `PHEN`,
  baseURL: `https://api.phenix295.com`,
  baseURLBE: `https://office.phenix295.com/api/`,
  enpoint: ``,
  logo: Logos.phenix.normal,
  logoLight: Logos.phenix.light,
  cover: Logos.phenix.cover,
  cssPrefix: `phenix295`,
  css: `/assets/css/phenix295.css`,
  lineQrCode: Logos.phenix.qrcode,
  lineId: `@phenix295`,
  lineUrl: `https://lin.ee/ZiHLVA6`,
  favicon: ``,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const ufo98 = {
  app_name: `UFO98BET`,
  prefix: `LION`,
  baseURL: `https://api.168lionbet.com`,
  baseURLBE: `https://ag.168lionbet.com/api/`,
  enpoint: ``,
  logo: Logos.ufo98.normal,
  logoLight: Logos.ufo98.light,
  cover: Logos.ufo98.cover,
  cssPrefix: `ufo98`,
  css: `/assets/css/ufo98.css`,
  lineQrCode: Logos.ufo98.qrcode,
  lineId: `@ufo98bet`,
  lineUrl: `https://line.me/R/ti/p/@654kkelq`,
  favicon: `/assets/images/partners/ufo98/favicon.ico`,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const vipaclub = {
  app_name: `VIPACLUB`,
  prefix: `VIPA`,
  baseURL: `https://api.vipaclub88.com`,
  baseURLBE: `https://office.vipaclub88.com/api/`,
  enpoint: ``,
  logo: Logos.vipaclub.normal,
  logoLight: Logos.vipaclub.light,
  cover: Logos.vipaclub.cover,
  cssPrefix: `vipaclub`,
  css: `/assets/css/vipaclub.css`,
  lineQrCode: Logos.vipaclub.qrcode,
  lineId: `@vipaclub88`,
  lineUrl: `https://lin.ee/3mi2pdK`,
  favicon: ``,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const octa8888 = {
  app_name: `OCTA8888`,
  prefix: `OCTA`,
  baseURL: `https://api.octa8888.com`,
  baseURLBE: `https://office.octa8888.com/api/`,
  enpoint: ``,
  logo: Logos.octa8888.normal,
  logoLight: Logos.octa8888.light,
  cover: Logos.octa8888.cover,
  cssPrefix: `octa8888`,
  css: `/assets/css/octa8888.css`,
  lineQrCode: `../assets/images/partners/octa8888/qr-code-octa8888.jpg`,
  whatsappQrCode: `../assets/images/partners/octa8888/qr-code-octa8888-whatsapp.jpg`,
  lineId: `@OCTAx`,
  lineUrl: `https://lin.ee/fO7Tp1V`,
  favicon: `/assets/images/partners/octa8888/favicon.ico`,
  hideWalletLabel: true,
  featurehoro: false,
  qrservice: false,
  qrdisable: true,
  webservice: true,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: true,
};

const phenix168 = {
  app_name: `Phenix168`,
  prefix: `PHE8`,
  baseURL: `https://api.phenix168.com`,
  baseURLBE: `https://office.phenix168.com/api/`,
  enpoint: ``,
  logo: Logos.phenix168.normal,
  logoLight: Logos.phenix168.light,
  cover: Logos.phenix168.cover,
  cssPrefix: `phenix168`,
  css: `/assets/css/phenix168.css`,
  lineQrCode: Logos.phenix168.qrcode,
  lineId: `@phenix168`,
  lineUrl: `https://lin.ee/ZiHLVA6`,
  favicon: ``,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const dragon168 = {
  app_name: `OCTA8888`,
  prefix: `OCTA`,
  baseURL: `https://api.octa8888.com`,
  baseURLBE: `https://office.octa8888.com/api/`,
  enpoint: ``,
  logo: Logos.dragon.normal,
  logoLight: Logos.dragon.light,
  cover: Logos.dragon.cover,
  cssPrefix: `dragon`,
  css: `/assets/css/dragon168.css`,
  lineQrCode: Logos.dragon.qrcode,
  lineId: `@octa888`,
  lineUrl: `https://lin.ee/@dragon`,
  favicon: `/assets/images/partners/dragon/favicon.ico`,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const lion168 = {
  app_name: `LION168`,
  prefix: `LION`,
  baseURL: `https://api.168lionx.com`,
  baseURLBE: `https://office.168lionx.com/api/`,
  enpoint: ``,
  logo: Logos.lion.normal,
  logoLight: Logos.lion.light,
  cover: Logos.lion.cover,
  cssPrefix: `lion`,
  css: `/assets/css/lion168.css`,
  lineQrCode: Logos.lion.qrcode,
  lineId: `@168lion`,
  lineUrl: `https://lin.ee/qLFs8eCR`,
  favicon: `/assets/images/partners/lion168/favicon.ico`,
  pgprovider: `PGSOFT2`,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const lion168Test = {
  app_name: `LION168`,
  prefix: `LION`,
  baseURL: `https://api.168lionbet.com`,
  baseURLBE: `https://ag.168lionbet.com/api/`,
  enpoint: ``,
  logo: logoTest,
  logoLight: logoTest,
  cover: logoCover,
  cssPrefix: `octa8888`,
  css: `/assets/css/octa8888.css`,
  lineQrCode: ``,
  lineId: ``,
  lineUrl: ``,
  favicon: `/assets/images/partners/octa8888/favicon.ico`,
  dev: true,
  hideWalletLabel: true,
  featurehoro: true,
  qrdisable: false,
  webservice: false,
  loginlogo: true,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const octa8888Test = {
  app_name: `LION168`,
  prefix: `LION`,
  baseURL: `https://api.168lionbet.com`,
  baseURLBE: `https://ag.168lionbet.com/api/`,
  enpoint: ``,
  logo: Logos.octa8888.normal,
  logoLight: Logos.octa8888.light,
  cover: Logos.octa8888.cover,
  cssPrefix: `octa8888`,
  css: `/assets/css/octa8888.css`,
  lineQrCode: Logos.octa8888.qrcode,
  lineId: `@octa888`,
  lineUrl: `https://lin.ee/LDR3PsL`,
  favicon: `/assets/images/partners/octa8888/favicon.ico`,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const sg168 = {
  app_name: `SG168`,
  prefix: `SGAM`,
  baseURL: `https://api.sgaming168.com`,
  baseURLBE: `https://office.sgaming168.com/api/`,
  enpoint: ``,
  logo: Logos.sg168.normal,
  logoLight: Logos.sg168.light,
  cover: Logos.sg168.cover,
  cssPrefix: `sg168`,
  css: `/assets/css/vipaclub.css`,
  lineQrCode: Logos.sg168.qrcode,
  lineId: `@sgm168`,
  lineUrl: `https://lin.ee/UFrYBVi`,
  favicon: ``,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const axe888 = {
  app_name: `AXE888`,
  prefix: `AXE8`,
  baseURL: `https://api.axe888.com`,
  baseURLBE: `https://office.axe888.com/api/`,
  enpoint: ``,
  logo: Logos.axe888.normal,
  logoLight: Logos.axe888.light,
  cover: Logos.axe888.cover,
  cssPrefix: `axe888`,
  css: `/assets/css/axe888.css`,
  lineQrCode: Logos.axe888.qrcode,
  lineId: `@axe888`,
  lineUrl: `https://liff.line.me/1645278921-kWRPP32q/?accountId=axe888`,
  favicon: ``,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const wishdom = {
  app_name: `wisdom`,
  prefix: `WISD`,
  baseURL: `https://api.wisdoms.asia`,
  baseURLBE: `https://office.wisdoms.asia/api/`,
  enpoint: ``,
  logo: Logos.wishdom.normal,
  logoLight: Logos.wishdom.light,
  cover: Logos.wishdom.cover,
  cssPrefix: `wishdom`,
  css: `/assets/css/wishdom.css`,
  lineQrCode: Logos.wishdom.qrcode,
  lineId: `@wisdom168`,
  lineUrl: `https://bit.ly/wisdom168`,
  favicon: ``,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const wishdomTest = {
  app_name: `wisdom`,
  prefix: `LION`,
  baseURL: `https://api.168lionbet.com`,
  baseURLBE: `https://ag.168lionbet.com/api/`,
  enpoint: ``,
  logo: Logos.wishdom.normal,
  logoLight: Logos.wishdom.light,
  cover: Logos.wishdom.cover,
  cssPrefix: `wishdom`,
  css: `/assets/css/wishdom.css`,
  lineQrCode: Logos.wishdom.qrcode,
  lineId: `@wisdom168`,
  lineUrl: `https://bit.ly/wisdom168`,
  favicon: ``,
  hideWalletLabel: true,
  featurehoro: true,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const diamon = {
  app_name: `diamond`,
  prefix: `DIAM`,
  baseURL: `https://api.diamond458.com`,
  baseURLBE: `https://office.diamond458.com/api/`,
  enpoint: ``,
  logo: `/assets/images/partners/diamond/logo.png`,
  logoLight: `/assets/images/partners/diamond/logo-light.png`,
  cover: `/assets/images/partners/diamond/cover.png`,
  cssPrefix: `diamond`,
  css: `/assets/css/diamond.css`,
  lineQrCode: `/assets/images/partners/diamond/qr.png`,
  lineId: `@diam458`,
  lineUrl: `https://lin.ee/C4A9Dtb`,
  favicon: ``,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const slotslao = {
  app_name: `diamond`,
  prefix: `SLOS`,
  baseURL: `https://api.slotslao.com`,
  baseURLBE: `https://office.slotslao.com/api/`,
  enpoint: ``,
  logo: `/assets/images/partners/diamond/logo.png`,
  logoLight: `/assets/images/partners/diamond/logo-light.png`,
  cover: `/assets/images/partners/diamond/cover.png`,
  cssPrefix: `diamond`,
  css: `/assets/css/diamond.css`,
  lineQrCode: `/assets/images/partners/diamond/qr.jpg`,
  lineId: `@571upfez`,
  lineUrl: `https://lin.ee/aXslUSb`,
  favicon: ``,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const pklaos88 = {
  app_name: `PKLAOS88`,
  prefix: `PKLA`,
  baseURL: `https://api.pklaos88.com`,
  baseURLBE: `https://office.pklaos88.com/api/`,
  enpoint: ``,
  logo: `/assets/images/partners/pklaos88/logo.png`,
  logoLight: `/assets/images/partners/pklaos88/logo-light.png`,
  cover: `/assets/images/partners/pklaos88/cover.png`,
  cssPrefix: `pklaos88`,
  lineQrCode: `/assets/images/partners/pklaos88/qr.jpg`,
  css: `/assets/css/pklaos88.css`,
  lineId: ``,
  lineUrl: ``,
  favicon: `/assets/images/partners/pklaos88/favicon.ico`,
  dev: true,
  hideWalletLabel: true,
  featurehoro: false,
  loginlogo: true,
  qrdisable: false,
  webservice: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const acfbet = {
  app_name: `AFCB`,
  prefix: `AFCB`,
  baseURL: `https://api.afcbet.net`,
  baseURLBE: `https://office.afcbet.net/api/`,
  enpoint: ``,
  logo: `/assets/images/partners/acfbet/afcbet-logo.jpg`,
  logoLight: `/assets/images/partners/acfbet/logo-light.png`,
  cover: `/assets/images/partners/acfbet/cover.png`,
  cssPrefix: `acfbet`,
  lineQrCode: `/assets/images/partners/acfbet/qr.png`,
  css: `/assets/css/acfbet.css`,
  lineId: `@903kmdje`,
  lineUrl: `https://lin.ee/rrm3F34`,
  favicon: `/assets/images/partners/acfbet/favicon.ico`,
  dev: true,
  hideWalletLabel: true,
  featurehoro: true,
  featuregame: false,
  loginlogo: true,
  qrdisable: true,
  webservice: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const wisdom68 = {
  app_name: `WSDM`,
  prefix: `WSDM`,
  baseURL: `https://api.wisdom368.com`,
  baseURLBE: `https://office.wisdom368.com/api/`,
  enpoint: ``,
  logo: `/assets/images/partners/wisdom68/logo.png`,
  logoLight: `/assets/images/partners/wisdom68/logo-light.png`,
  cover: `/assets/images/partners/wisdom68/cover.png`,
  cssPrefix: `wisdom68`,
  lineQrCode: `/assets/images/partners/wisdom68/qr.png`,
  css: `/assets/css/wisdom68.css`,
  lineId: `@903kmdje`,
  lineUrl: `https://lin.ee/rrm3F34`,
  favicon: `/assets/images/partners/wisdom68/favicon.ico`,
  dev: true,
  hideWalletLabel: true,
  featurehoro: true,
  featuregame: false,
  loginlogo: true,
  qrdisable: false,
  webservice: false,
  usetype1: false,
  usetype2: true,
  depositContact: false,
};

const ox888 = {
  app_name: `OX888`,
  prefix: `OXOX`,
  baseURL: `https://api.ox888.vip`,
  baseURLBE: `https://office.ox888.vip/api/`,
  // app_name: `LION168`,
  // prefix: `LION`,
  // baseURL: `https://api.168lionbet.com`,
  // baseURLBE: `https://ag.168lionbet.com/api/`,
  enpoint: ``,
  logo: `/assets/images/partners/ox888/logo.webp`,
  logoLight: `/assets/images/partners/ox888/logo-light.png`,
  cover: ``,
  cssPrefix: `ox888`,
  lineQrCode: `/assets/images/partners/ox888/promotion-ox.jpg`,
  css: `/assets/css/ox888.css`,
  lineId: ``,
  lineUrl: `https://lin.ee/iArojJG`,
  favicon: `/assets/images/partners/ox888/favicon.ico`,
  dev: true,
  hideWalletLabel: true,
  featurehoro: true,
  featuregame: false,
  loginlogo: true,
  qrdisable: false,
  webservice: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const bet168lionTest = {
  app_name: `LION168`,
  prefix: `LION`,
  baseURL: `https://api.168lionbet.com`,
  baseURLBE: `https://ag.168lionbet.com/api/`,
  enpoint: ``,
  logo: `/assets/images/partners/bet168lion/Better-Bet.png`,
  logoLight: `/assets/images/partners/bet168lion/Better-Bet-light.png`,
  cover: `/assets/images/partners/bet168lion/Better-Bet.png`,
  cssPrefix: `octa8888`,
  css: `/assets/css/bet168lion.css`,
  lineQrCode: Logos.octa8888.qrcode,
  lineId: `@octa888`,
  lineUrl: `https://lin.ee/LDR3PsL`,
  favicon: `/assets/images/partners/octa8888/favicon.ico`,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: true,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const bugano168 = {
  app_name: `BUGANO168`,
  prefix: `BUGA`,
  baseURL: `https://api.bugano168.com`,
  baseURLBE: `https://office.bugano168.com/api/`,
  enpoint: ``,
  logo: `/assets/images/partners/bugano168/bugano.png`,
  logoLight: `/assets/images/partners/bugano168/logo-dark.png`,
  cover: `/assets/images/partners/bugano168/cover.png`,
  cssPrefix: `bugano168`,
  css: `/assets/css/bugano168.css`,
  lineQrCode: `/assets/images/partners/bugano168/qr.jpg`,
  lineId: `@bugano168`,
  lineUrl: `https://lin.ee/qjYImjV`,
  favicon: `/assets/images/partners/bugano168/favicon.ico`,
  hideWalletLabel: true,
  featurehoro: true,
  featuregame: false,
  qrdisable: false,
  webservice: false,
  loginlogo: true,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const ferrari888 = {
  app_name: `ferrari888`,
  prefix: `FERR`,
  baseURL: `https://api.ferrari888.vip`,
  baseURLBE: `https://office.ferrari888.vip/api/`,
  enpoint: ``,
  logo: `/assets/images/partners/ferrari888/logo.png`,
  logoLight: `/assets/images/partners/ferrari888/logo-light.png`,
  cover: ``,
  cssPrefix: `ferrari888`,
  css: `/assets/css/ferrari888.css`,
  lineQrCode: `/assets/images/partners/ferrari888/qrcode-ferrari.png`,
  lineId: `@frri888`,
  lineUrl: `https://lin.ee/IVLrAIq`,
  favicon: `/assets/images/partners/ferrari888/favicon.ico`,
  hideWalletLabel: true,
  featurehoro: true,
  featuregame: false,
  pgslot: true,
  qrdisable: false,
  webservice: false,
  loginlogo: true,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const superboss789 = {
  app_name: `Superboss789`,
  prefix: `LION`,
  baseURL: `https://api.168lionbet.com`,
  baseURLBE: `https://ag.168lionbet.com/api/`,
  enpoint: ``,
  logo: `/assets/images/partners/superboss789/logo.png`,
  logoLight: `/assets/images/partners/superboss789/logo-light.png`,
  cover: ``,
  cssPrefix: `superboss789`,
  css: `/assets/css/superboss789.css`,
  lineQrCode: `/assets/images/partners/superboss789/qr.jpg`,
  lineId: `@superboss789`,
  lineUrl: `https://lin.ee/WAhpP24`,
  favicon: `/assets/images/partners/superboss789/favicon.ico`,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: true,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const lion168pklaos = {
  app_name: `LION168`,
  prefix: `LION`,
  baseURL: `https://api.pklaos88.online`,
  baseURLBE: `https://ag.pklaos88.online/api/`,
  enpoint: ``,
  logo: logoTest,
  logoLight: logoTest,
  cover: logoCover,
  cssPrefix: `octa8888`,
  css: `/assets/css/octa8888.css`,
  lineQrCode: ``,
  lineId: ``,
  lineUrl: ``,
  favicon: `/assets/images/partners/octa8888/favicon.ico`,
  dev: true,
  hideWalletLabel: true,
  featurehoro: true,
  qrdisable: false,
  webservice: false,
  loginlogo: true,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const veitnamWeb = {
  app_name: `LION168`,
  prefix: `LION`,
  baseURL: `https://api.168lionbet.com`,
  baseURLBE: `https://ag.168lionbet.com/api/`,
  enpoint: ``,
  logo: `/assets/images/partners/vietnamWeb/logo.png`,
  logoLight: `/assets/images/partners/octa8888/logo-light.png`,
  cover: `/assets/images/partners/vietnamWeb/bg-overlay-full.png`,
  cssPrefix: `octa8888`,
  css: `/assets/css/veitnamWeb.css`,
  lineQrCode: ``,
  lineId: ``,
  lineUrl: ``,
  favicon: `/assets/images/partners/vietnamWeb/favicon.ico`,
  dev: true,
  hideWalletLabel: true,
  featurehoro: true,
  qrdisable: false,
  webservice: false,
  loginlogo: true,
  usetype1: false,
  usetype2: true,
  depositContact: false,
};

const k789x = {
  app_name: `789X`,
  prefix: `KING`,
  baseURL: `https://api.789x.asia`,
  baseURLBE: `https://office.789x.asia/api/`,
  enpoint: ``,
  logo: `/assets/images/partners/k88/logo-new.png`,
  logoLight: `/assets/images/partners/k88/logo-light-new.png`,
  cover: `/assets/images/partners/k88/cover.png`,
  cssPrefix: `king888`,
  css: `/assets/css/k88.css`,
  lineQrCode: `/assets/images/partners/k88/qr.png`,
  lineId: `@k88`,
  lineUrl: `https://lin.ee/C4A9Dtb`,
  favicon: ``,
  hideWalletLabel: true,
  featurehoro: false,
  qrdisable: false,
  webservice: false,
  loginlogo: false,
  usetype1: true,
  usetype2: false,
  depositContact: false,
};

const APP = axe888;
export default APP;
